var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpcInfraLegend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_629_108311)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(14 10)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26.875H18.375C18.0438 26.874 17.7264 26.742 17.4922 26.5078C17.258 26.2736 17.126 25.9562 17.125 25.625V17.5H18.375V25.625H26.5V26.875Z",
    fill: "#1192E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.625 23.75L26.125 21.25C26.3706 20.8794 26.501 20.4445 26.5 20C26.4981 19.3376 26.234 18.7028 25.7656 18.2344C25.2972 17.766 24.6624 17.5019 24 17.5C23.5555 17.499 23.1206 17.6294 22.75 17.875L20.25 15.375V11.25H15.25V16.25H19.375L21.875 18.75C21.6294 19.1206 21.499 19.5555 21.5 20C21.5019 20.6624 21.766 21.2972 22.2344 21.7656C22.7028 22.234 23.3376 22.4981 24 22.5C24.4445 22.501 24.8794 22.3706 25.25 22.125L27.75 24.625V28.75H32.75V23.75H28.625ZM19 15H16.5V12.5H19V15ZM24 21.25C23.7528 21.25 23.5111 21.1767 23.3055 21.0393C23.1 20.902 22.9398 20.7068 22.8452 20.4784C22.7505 20.2499 22.7258 19.9986 22.774 19.7561C22.8222 19.5137 22.9413 19.2909 23.1161 19.1161C23.2909 18.9413 23.5137 18.8222 23.7561 18.774C23.9986 18.7258 24.2499 18.7505 24.4784 18.8452C24.7068 18.9398 24.902 19.1 25.0393 19.3055C25.1767 19.5111 25.25 19.7528 25.25 20C25.249 20.3312 25.117 20.6486 24.8828 20.8828C24.6486 21.117 24.3312 21.249 24 21.25ZM31.5 27.5H29V25H31.5V27.5Z",
    fill: "#1192E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 22.5H30.875V14.375C30.874 14.0438 30.742 13.7264 30.5078 13.4922C30.2736 13.258 29.9562 13.126 29.625 13.125H21.5V14.375H29.625V22.5Z",
    fill: "#1192E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_629_108311",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_629_108311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_629_108311",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpcInfraLegend);
export default __webpack_public_path__ + "static/media/vpcInfraLegend.b25264cabd5341c0412d318d9125fbdd.svg";
export { ForwardRef as ReactComponent };